import { invokeApi } from "../../bl_libs/invokeApi";

export const getTrackerQuestionsApi = async ({
  page = 1,
  limit = 100,
  search = "",
  mode = "",
  status = "",
} = {}) => {
  const queryParams = [];
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  if (mode && mode !== "all") queryParams.push(`mode=${encodeURIComponent(mode)}`);
  if (status) queryParams.push(`status=${encodeURIComponent(status)}`);

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  const requestObj = {
    path: `api/tracker_question${queryString}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getTrackerQuestionDetailApi = async (id) => {
  const requestObj = {
    path: `api/tracker_question/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const addTrackerQuestionApi = async (data) => {
  const requestObj = {
    path: `api/tracker_question`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const updateTrackerQuestionApi = async (id, data) => {
  const requestObj = {
    path: `api/tracker_question/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const deleteTrackerQuestionApi = async (id) => {
  const requestObj = {
    path: `api/tracker_question/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const seedStarterQuestionsApi = async (force = false) => {
  const requestObj = {
    path: `api/tracker_question/seed_starter`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { force },
  };
  return invokeApi(requestObj);
};
